<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography" style="display: inline">
  {{data.text}}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>